/**
 * Returns the given search string with the `source` param removed.
 * Used when building org-scoped search redirect URLs so we don't carry over consumer search source.
 * Output is normalized to percent-encoded form (%20 for spaces) for consistency.
 */
export function searchQueryWithoutSource(search: string): string {
  const params = new URLSearchParams(search.replace(/^\?/, ''));
  params.delete('source');
  const q = params.toString();
  if (!q) return '';
  return '?' + q.replace(/\+/g, '%20');
}

/**
 * Normalizes a URL search string to a canonical form (percent-encoded, e.g. %20 for spaces).
 * Use when building redirect URLs so output is consistent whether the source used + or %20 for spaces.
 * (URLSearchParams.toString() uses + in Node but %20 in some browsers; we force %20 for consistency.)
 */
export function normalizeSearchString(search: string): string {
  if (!search || search === '?') return '';
  const params = new URLSearchParams(search.replace(/^\?/, ''));
  const q = params.toString();
  if (!q) return '';
  // Force %20 for spaces so redirect URLs are consistent across environments (Node uses + in toString())
  return '?' + q.replace(/\+/g, '%20');
}
